module.exports = __webpack_public_path__ + "static/media/adminIcon03.eb7342bf.svg";